<template>
  <div>
    <MTop title="修改密码" />
    <div style="padding:20px;margin-top:20px;" class="bgc-white">
      <el-form
        label-position="top"
        :model="formData"
        label-width="150px"
        ref="formData"
        :rules="rules"
      >
        <el-form-item label="当前密码：" prop="oldPassword">
          <el-input
            show-password
            auto-complete="false"
            type="password"
            v-model="formData.oldPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPassword">
          <el-input
            show-password
            auto-complete="false"
            type="password"
            v-model="formData.newPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码：" prop="confirmPassword">
          <el-input
            show-password
            auto-complete="false"
            type="password"
            v-model="formData.confirmPassword"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="success" style="width:100%;margin-top:20px;" @click="updatePassword">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data: function () {
    var ValidatePass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请填写新的密码'))
      } else {
        var patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
        if (patrn.test(value)) {
          callback()
        } else {
          callback(new Error('密码至少包含一个数字、一个字母、6~16个字符'))
        }
      }
    }
    var ValidateConfirmPassWord = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.newPassword) {
        callback(new Error('两次输入密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: ValidatePass, trigger: 'change'}
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: ValidateConfirmPassWord, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    logout: async function () {
      var res = await this.$http.post(`/v1/bqUser/logout`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.$message.success('退出登录')
        this.$router.push('/login')
      } else {
        this.$message.error(message)
      }
    },
    updatePassword: async function () {
      var res = await this.$http.post(
        `/v1/userInfo/updatePassword`,
        qs.stringify(this.formData)
      )
      var { code, message, data } = res.data
      if (code == 0) {
        // this.$message.success("修改密码成功，请重新登录！");
        this.$layer.toast({
          icon: 'icon-check', // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: '修改密码成功，请重新登录！',
          time: 2500 // 自动消失时间 toast类型默认消失时间为2000毫秒
        })
        window.localStorage.removeItem('token')
        this.$router.push('/login')
      } else if (code == 40100) {
        // this.$message({
        //   message: message,
        //   type: "error",
        //   duration: "1000"
        // });
        this.$layer.toast({
          icon: 'icon-check',
          content: message,
          time: 1000
        })
        this.$router.push('/login')
      } else {
        this.$layer.toast({
          icon: 'icon-check',
          content: message,
          time: 1000
        })
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mobile/personinfo/editpwd.vue